import { render, staticRenderFns } from "./AdminTab_Preferences.vue?vue&type=template&id=154b37ab&scoped=true"
import script from "./AdminTab_Preferences.vue?vue&type=script&lang=js"
export * from "./AdminTab_Preferences.vue?vue&type=script&lang=js"
import style0 from "./AdminTab_Preferences.vue?vue&type=style&index=0&id=154b37ab&prod&lang=css"
import style1 from "./AdminTab_Preferences.vue?vue&type=style&index=1&id=154b37ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154b37ab",
  null
  
)

export default component.exports